import { jsxs, jsx } from 'react/jsx-runtime';
import { styled, typographyClasses, Typography } from '@mui/material';
import { YearPicker } from './YearPicker.js';

const CalendarHeaderMonth = ({ yearsOffset = 5, monthDate, locale, changeYear, customHeaderCount, isSingleCalendar, }) => {
    const monthText = monthDate.toLocaleString(locale, {
        month: "long",
        year: "numeric",
    });
    return (jsxs(CalendarMonthWrapper, { "$mode": getCalendarMode(isSingleCalendar, customHeaderCount), children: [jsx(Typography, { color: "text.high", sx: { letterSpacing: 0 }, variant: "button", children: monthText }), jsx(YearPicker, { monthDate: monthDate, yearsOffset: yearsOffset, onChangeYear: changeYear })] }));
};
const CalendarMonthWrapper = styled("div")(({ theme, $mode }) => (Object.assign(Object.assign(Object.assign({ display: "flex", alignItems: "center", justifyContent: "center", flexGrow: 1 }, ($mode === "single" && { padding: theme.spacing(0, 1.5) })), ($mode !== "single" && Object.assign(Object.assign({}, ($mode === "left" && {
    justifyContent: "flex-start",
    marginLeft: theme.spacing(3),
})), ($mode === "right" && {
    justifyContent: "flex-end",
    marginRight: theme.spacing(3),
})))), { [`& > .${typographyClasses.root}`]: {
        textAlign: "center",
        marginRight: theme.spacing(1),
    } })));
function getCalendarMode(isSingleCalendar, customHeaderCount) {
    if (isSingleCalendar) {
        return "single";
    }
    if (customHeaderCount === 0) {
        return "left";
    }
    return "right";
}

export { CalendarHeaderMonth };
//# sourceMappingURL=HeaderMonth.js.map
